import { FC } from "react";
import styled from "styled-components";
import { additionalProducts } from "../../__generated__/additionalProducts";
import SelectionFilter from "../common/SelectionFilter";
import { IngredientWithPrice } from "./ProductCard";

const CrustsSelect: FC<{
  data: additionalProducts;
  variantName: string;
  onSelect: (variant?: IngredientWithPrice) => void;
}> = ({ data, variantName, onSelect }) => {
  const variants = data.shop.collections[0].products
    .reduce((acc, next) => {
      const newAcc = [...acc, ...next.variants];
      return newAcc;
    }, [])
    .filter((v) => v.name === variantName);

  if (!variants.length) {
    return null;
  }

  return (
    <>
      <Label>Выберите бортик</Label>
      {/* <TomatoBlock>
        <img src="/static/images/tomato.png" width={60} height={54} />
        <TomatoCol>
          <TomatoTitle>При заказе пиццы с бортом с начинкой</TomatoTitle>
          <TomatoDescription>
            Фирменный томатный соус в подарок.
          </TomatoDescription>
        </TomatoCol>
      </TomatoBlock> */}
      <CustomSelectionFilter
        minWidth={115}
        isDetail
        options={[
          {
            value: "Традиционный",
            description: "Бесплатно",
          },
          ...variants.map(({ name, product, price }) => ({
            value: product.name,
            description: `+ ${price}₽`,
          })),
        ]}
        onChange={(value) => {
          const activeVariant = variants.find((v) => v.product.name === value);

          if (!activeVariant) {
            onSelect(null);
            return;
          }

          const result: IngredientWithPrice = {
            id: activeVariant.id,
            name: activeVariant.product.name,
            amount: 1,
            price: activeVariant.price,
          };

          onSelect(result);
        }}
        selectedDefault="Традиционный"
      />
    </>
  );
};

const CustomSelectionFilter = styled(SelectionFilter)`
  margin-bottom: 35px;
`;

const Label = styled.p`
  font-weight: bold;
  font-size: 16px;
  margin: 0;
`;

const TomatoBlock = styled.div`
  display: flex;
  align-items: center;
  margin: 14px 0;
`;

const TomatoCol = styled.div`
  margin-left: 10px;
`;

const TomatoTitle = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
`;

const TomatoDescription = styled.p`
  margin: 0;
  font-size: 12px;
  opacity: 0.5;
  line-height: 1.5;
`;

export default CrustsSelect;
